import {Injectable} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {finalize, Observable, tap} from 'rxjs';
import {Router} from "@angular/router";

@Injectable()
export class HttpErrorsInterceptor implements HttpInterceptor {

  constructor(private readonly router: Router) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('/content/')) {
      let errorResponse: HttpErrorResponse;

      return next.handle(request)
        .pipe(
          tap({next: () => errorResponse = null, error: (error) => errorResponse = error}),
          finalize(() => {
            if (errorResponse) {
              this.handleContentError(errorResponse);
            }
          })
        );
    } else {
      return next.handle(request);
    }
  }

  private handleContentError(error: HttpErrorResponse) {
    if (error.status == 505) {
      this.router.navigate(['error', '505']);
    } else if (error.status >= 500) {
      this.router.navigate(['error', '500']);
    }
  }
}

export const httpErrorsInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: HttpErrorsInterceptor,
  multi: true
}
